// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__t7oCN","textarea":"styles_textarea__3U6ca"};